import { ProgressBarState } from "../../ProgressBarView/types";

export function getProgress(
  state: ProgressBarState,
  getWeight: (index: number) => number,
  remainingWeight: number = 0
) {
  const { breakpoints, remaining } = state;

  const result = { value: 0, total: 0 };
  for (let i = 0; i < breakpoints.length; i++) {
    const breakpoint = breakpoints[i];
    const weight = getWeight(i);
    result.value += weight * breakpoint.progress;
    result.total += weight * 100;
  }
  result.value += remainingWeight * remaining;
  result.total += remainingWeight * 100;

  const tmp = 100 * (result.value / result.total);
  if (tmp < 0) {
    return 0;
  } else if (tmp > 100) {
    return 100;
  } else {
    return Math.round(tmp);
  }
}
